import React from "react";
import { Field, FormikHelpers } from "formik";
import { Box, Button } from "@mui/material";

import { ICode } from "../DiscountsModal/types";
import { FormInput } from "../index";
import { generateRandomString } from "../../../utils";

interface IProps {
  label: string;
  setFieldValue: FormikHelpers<ICode>["setFieldValue"];
  name: string;
}
const InputWithRandomGeneratorString: React.FC<IProps> = ({ label, name, setFieldValue }) => {
  return (
    <Box display="flex" justifyContent="space-between" mb="20px">
      <Box width="66%">
        <Field name={name} label={label} component={FormInput} variant="standard" />
      </Box>
      <Button
        data-test="generate-discount-code-button"
        size="small"
        onClick={() => setFieldValue(name, generateRandomString(7))}
      >
        Generate
      </Button>
    </Box>
  );
};

export default InputWithRandomGeneratorString;
